import 'lib-flexible/flexible'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/scss/index.scss'
import { clearNoNum } from '@/utils';
import FastClick from 'fastclick';
// let VConsole = require('../node_modules/vconsole/dist/vconsole.min')
// let vConsole = new VConsole();
// Vue.use(vConsole)
//FastClick的ios点击穿透解决方案
FastClick.prototype.focus = function (targetElement) {
  let length;
  if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
};
FastClick.attach(document.body);
Vue.config.productionTip = false

Vue.prototype.clearNoNum = clearNoNum;     // 清除非数字

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
